import styles from "./sharedStyled.module.scss";

export const AllDropDown = (props) => {
  const { children, className } = props;
  return (
    <div className={`${styles.all_dropdown} ${className}`}>
      {children}
    </div>
  );
};
